<template>
  <nav class="primary-menu" role="navigation">
    <ul>
      <li v-for="item in menu" :key="item.name">
        <component
          :is="item.link ? 'a' : 'button'"
          :id="primaryMenuId(item)"
          :href="item.link ? item.link : false"
          :class="{
            active: primaryMenuActiveItem === item.name
          }"
          :aria-current="ariaCurrent(item)"
          @click.prevent="$emit('menuSelected', item)"
        >
          <span class="elements-inner-wrapper" tabindex="-1">
            <span :class="['icon', 'af-icons', 'af-icons-' + item.icon]"></span>
            <span class="text">{{ item.text }}</span>
          </span>
        </component>
        <sub-menu
          v-if="hasSubMenu(item)"
          :sub-menu="item"
          :current-url="currentUrl"
          :primary-menu-active-item="primaryMenuActiveItem"
          :primary-menu-open="primaryMenuOpen"
          :labelled-by="primaryMenuId(item)"
          @itemSelected="item => $emit('itemSelected', item)"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import SubMenu from './PrimaryMenuSubMenu';

export default {
  components: {
    SubMenu
  },
  props: {
    menu: {
      type: Array,
      default: () => []
    },
    currentUrl: {
      type: String,
      default: null
    },
    primaryMenuActiveItem: {
      type: String,
      default: null
    },
    primaryMenuOpen: {
      type: Boolean,
      default: true
    },
    twoLevelMenus: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    hasSubMenu(item) {
      return (
        item.children &&
        item.children.length &&
        !this.twoLevelMenus.includes(item.name)
      );
    },
    primaryMenuId(item) {
      return 'primary-menu-' + item.name;
    },
    ariaCurrent(item) {
      if (this.primaryMenuActiveItem === item.name) {
        return 'page';
      }
    }
  }
};
</script>
